export * as Api from './api';

export enum KycProcessStatus {
  InProgress = 'IN_PROGRESS',
  Processing = 'PROCESSING',
  Reset = 'RESET',
  Failed = 'FAILED',
  Passed = 'PASSED',
  ManuallyApproved = 'MANUALLY_APPROVED',
  AdminApproved = 'ADMIN_APPROVED',
  NotAttempted = 'NOT_ATTEMPTED',
}

export enum KycRiskRating {
  Low = 'LOW',
  Medium = 'MEDIUM',
  MediumOrHigh = 'MEDIUM_OR_HIGH',
  High = 'HIGH',
}

export enum AmlResultsArchiveStatus {
  NotArchived = 'NOT_ARCHIVED',
  Archived = 'ARCHIVED',
  All = 'ALL',
}
